import React from 'react';
import { BeakerIcon, CheckCircleIcon, TruckIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';

function QualitySection() {
  const features = [
    {
      icon: BeakerIcon,
      title: "Top-Grade Materials",
      description: "We source high-quality materials specifically selected for civil construction, RCC structural works, and waterproofing to ensure strength and longevity.",
    },
    {
      icon: CheckCircleIcon,
      title: "Proven Workmanship",
      description: "Our team conducts rigorous quality checks at every project phase, ensuring precision in RCC structures and waterproofing, backed by years of expertise.",
    },
    {
      icon: TruckIcon,
      title: "On-time Delivery",
      description: "Our dedicated logistics network ensures timely delivery, no matter the size or complexity of the project.",
    },
    {
      icon: ShieldCheckIcon,
      title: "Durability & Safety",
      description: "We prioritize long-lasting solutions and safety in every project, ensuring robust and reliable results.",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="bg-white py-16 sm:py-24 px-4 sm:px-8 max-w-7xl mx-auto">
      <SectionHeading
        eyebrow="Why Choose Us"
        title="Why R.C. Bidave Civil Contractors and Suppliers"
      />

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8"
      >
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05, 
                y: -10,
                transition: { duration: 0.3 }
              }}
              className="flex flex-col items-center text-center group"
            >
              <motion.div
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
                className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-brand-navy to-brand-navy-light rounded-2xl shadow-lg group-hover:shadow-xl group-hover:from-brand-yellow group-hover:to-brand-gold transition-all duration-300"
              >
                <Icon className="w-10 h-10 sm:w-12 sm:h-12 text-brand-yellow group-hover:text-brand-navy transition-colors" aria-label={feature.title} />
              </motion.div>
              <h3 className="text-lg sm:text-xl font-semibold mt-4 text-gray-900 group-hover:text-brand-navy transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 mt-2 group-hover:text-gray-700 transition-colors">
                {feature.description}
              </p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
}

export default QualitySection;
